// booking.store.ts
import { Injectable, signal, computed } from "@angular/core";
import { Reservation, Aircraft, Instructor, Student } from "../../models";

@Injectable({ providedIn: "root" })
export class BookingStore {
  // Source-of-truth
  readonly open = 6;
  readonly close = 22;
  readonly step = 15;

  aircrafts = signal<Aircraft[]>([]);
  instructors = signal<Instructor[]>([]);
  students = signal<Student[]>([]);
  currentDate = signal<Date>(new Date());
  reservations = signal<Reservation[]>([]);

  // UI state
  selecting = signal(false);
  selection = signal<Reservation | null>(null);
  resizing = signal(false);
  dragging = signal(false);

  // dérivées
  hoursList = computed(() =>
    Array.from({ length: this.close - this.open }, (_, i) => i + this.open)
  );
  hoursCount = computed(() => this.close - this.open);

  // mutations “petites et pures”
  setReservations(res: Reservation[]) {
    this.reservations.set(res);
  }
  upsertReservation(patch: Reservation) {
    const next = [...this.reservations()];
    const i = next.findIndex(
      (r) => r.id === patch.id && r.rowType === patch.rowType
    );
    i >= 0 ? (next[i] = { ...next[i], ...patch }) : next.push(patch);
    this.reservations.set(next);
  }
  removeReservation(id: string) {
    this.reservations.set(this.reservations().filter((r) => r.id !== id));
  }
}
